/* Progressive enhancement only: shopping links and FAQs work without JavaScript. */
(() => {
  if (customElements.get('kaamil-editorial')) return;
  class KaamilEditorial extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const { signal } = this.abort;
      const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.observers = [];
      this.querySelectorAll('[data-ke-rail]').forEach((rail) => {
        const controls = rail.closest('section')?.querySelector('[data-ke-controls]');
        if (!controls) return;
        const previous = controls.querySelector('[data-ke-scroll="-1"]');
        const next = controls.querySelector('[data-ke-scroll="1"]');
        const rtl = () => getComputedStyle(rail).direction === 'rtl';
        const update = () => {
          const maximum = rail.scrollWidth - rail.clientWidth;
          const position = Math.abs(rail.scrollLeft);
          controls.hidden = maximum < 8;
          rail.tabIndex = maximum < 8 ? -1 : 0;
          previous.disabled = position < 4;
          next.disabled = position >= maximum - 4;
        };
        controls.addEventListener('click', (event) => {
          const button = event.target.closest('button[data-ke-scroll]');
          if (!button || button.disabled) return;
          const amount = Number(button.dataset.keScroll) * rail.clientWidth * .85 * (rtl() ? -1 : 1);
          rail.scrollBy({left: amount, behavior: motion()});
        }, {signal});
        rail.addEventListener('scroll', update, {passive: true, signal});
        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(update);
          observer.observe(rail); this.observers.push(observer);
        } else {
          window.addEventListener('resize', update, {passive: true, signal});
        }
        requestAnimationFrame(update);
      });
      this.querySelectorAll('.ke-video-guide').forEach((guide) => {
        guide.addEventListener('toggle', () => {
          if (!guide.open) guide.querySelectorAll('video').forEach((video) => video.pause());
        }, {signal});
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observers?.forEach((observer) => observer.disconnect());
    }
  }
  customElements.define('kaamil-editorial', KaamilEditorial);
})();
